export default __webpack_public_path__ + "static/1-1b83e3cbce9feab6557a57f1b1771713.jpeg";